module.exports = __webpack_public_path__ + "img/tean.fa6786ec.png";